import React from "react";
import AboutCard from "../about/AboutCard";
import HAbout from "./HAbout";
import Hero from "./hero/Hero";

const Home = () => {
  return (
    <>
      <Hero />
      <AboutCard />
      <HAbout />
    </>
  );
};

export default Home;
